import { render, staticRenderFns } from "./loyalty.vue?vue&type=template&id=3c836dc3"
import script from "./loyalty.vue?vue&type=script&lang=ts"
export * from "./loyalty.vue?vue&type=script&lang=ts"
import style0 from "./loyalty.vue?vue&type=style&index=0&id=3c836dc3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports